export const EXPERIMENT_GROUP_COOKIE_NAME = "cada-exp";
